import { Progress } from '@apps/web/components/ui/progress';
import { TrainingFlower } from '@apps/web/features/teach_phoebe/ui/training_flower';
import {
    clampedTrainingDay,
    TRAINING_PERIOD_DAYS,
    trainingProgressPercent,
} from '@apps/web/lib/training_mode';

// A borderless status band, not a card: the training day over a thin
// progress bar. The review queue below is the page's job; this only sets
// the scene.
export function ProgressCard({
    trainingDay,
}: {
    readonly trainingDay: number;
}) {
    const progressPercent = trainingProgressPercent(trainingDay);
    const displayedTrainingDay = clampedTrainingDay(trainingDay);
    return (
        <div className="relative" data-testid="teach-phoebe-progress-card">
            <TrainingFlower
                trainingDay={trainingDay}
                className="pointer-events-none absolute right-0 bottom-0 h-14"
            />
            <div className="pr-14">
                <p className="text-training text-sm font-semibold">
                    Day {displayedTrainingDay} of {TRAINING_PERIOD_DAYS}
                </p>
                <Progress
                    value={progressPercent}
                    className="bg-training/10 mt-2.5 h-1.5"
                    indicatorClassName="bg-training"
                />
            </div>
        </div>
    );
}
